// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sl20","left":"styles_left__26JJH"};